import { useMemo, useEffect } from 'react';
import { debounce } from 'lodash';

/**
 * Returns a memoized debounced callback function.
 *
 * https://lodash.com/docs/4.17.15#debounce
 *
 * @param {Function} callback The callback function
 * @param {Number} timeout Timeout in milliseconds
 */
export default function useDebounced(callback, timeout) {
    const debouncedFn = useMemo(() => debounce(callback, timeout), [callback, timeout]);

    // when unmounting, automatically kill off the debounced function
    useEffect(() => () => debouncedFn.cancel(), [debouncedFn]);

    return debouncedFn;
}
